import { Component, OnInit, NgZone } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ValidationsService } from '../../services/common/validations.service';
import { DashboardService } from '../../services/dashboard.service';
import { WindowRefService } from '../../services/window-ref.service';
import { environment } from '../../../environments/environment';
declare var $: any;
@Component({
  selector: 'app-billing-invoice',
  templateUrl: './billing-invoice.component.html',
  styleUrls: ['./billing-invoice.component.scss']
})
export class BillingInvoiceComponent implements OnInit {

  isLoading = true;
  apiResponse;
  activePlanName;

  // Additional Coupons and Buy More
  couponDetailsAndPriceResponse;
  isBuyMoreButtonClicked = false;

  // Edit Payment
  isEditPayment = false;
  isEditBillingInformation = false;

  // Update Plan
  upgradeActionButtonClicked = false;
  planDataToSend;
  modalRefToSend;
  flagToTriggerChangeEvent = 0;

  // Billing Information Form
  billingInformationForm: FormGroup;
  isBillingInformationFormSubmitted: boolean;
  billingFormSaveBtnLabel = 'Save Changes';

  // Payment Method Form (Update Card)
  // updatePaymentDetailsForm: FormGroup;
  // isUpdatePaymentDetailsFormSubmitted: boolean;

  // Send On Email
  sendOnEmailBtnRef;

  //
  noOfPages;
  offsetValue;

  constructor(private zone: NgZone, private windowRef: WindowRefService, private formBuilder: FormBuilder, private validationService: ValidationsService, private dashboardService: DashboardService) {
    // subscribe to subscription change request flag
    this.dashboardService.getPlanChangeRequestFlag().subscribe(data => {
      // console.log('get flag', data);
      this.apiResponse.plan_change_or_cancellation_request = data;
    });

    // subscribe to Coupons Bought Success flag
    this.dashboardService.getCouponBoughtFlag().subscribe(data => {
      // console.log('get coupon flag', data);
      this.zone.run(() => {
        $('#buyMoreCoupons').modal('hide');
        // this.apiResponse.coupon_purchase_history.count = parseInt(data.couponCount);
        // this.apiResponse.coupon_purchase_history.amount = parseInt(data.couponAmount);
        this.getBillingInfoPageDetails();
      });
    });
  }

  ngOnInit() {

    this.billingInformationForm = this.formBuilder.group({
      name: ['', Validators.required],
      phone: ['', [Validators.required, Validators.maxLength(10), Validators.pattern('[1-9][0-9]{9}')]],
      email: ['', [Validators.required, this.validationService.validateEmail]],
      gst: ['']
    });

    // this.updatePaymentDetailsForm = this.formBuilder.group({
    //   card_number: ['', Validators.required],
    //   card_expiry_date: ['', [Validators.required, Validators.pattern('(0[1-9]|10|11|12)[0-9]{2}')]],
    //   card_cvv: ['', [Validators.required, Validators.minLength(3)]]
    // });

    this.getBillingInfoPageDetails();
  }

  // getters - billingInformationForm
  get name() { return this.billingInformationForm.get('name'); }
  get phone() { return this.billingInformationForm.get('phone'); }
  get email() { return this.billingInformationForm.get('email'); }
  get gst() { return this.billingInformationForm.get('gst'); }

  // getters
  // get card_number() { return this.updatePaymentDetailsForm.get('card_number'); }
  // get card_expiry_date() { return this.updatePaymentDetailsForm.get('card_expiry_date'); }
  // get card_cvv() { return this.updatePaymentDetailsForm.get('card_cvv'); }

  // 
  getBillingInfoPageDetails() {
    this.dashboardService.getBillingInfoPageDetails().subscribe(response => {
      this.isLoading = false;
      if (response.statusCode == 200 && response.status == true) {
        this.apiResponse = response.data;
        this.noOfPages = response.data.bills_count;

        (response.data.plan).forEach(element => {
          if (element.activePlan == true) {
            this.zone.run(() => {
              this.activePlanName = element.plan;
            });
          }
        });

      }
      // console.log(response);
    });
  }


  // phone no.
  onlyNumericInput(event) {
    return this.validationService.isNumericInput(event);
  }

  // Upgrade, Downgrade, Cancel Renewal (Shared component - plan-action-modals)
  billingPlanAction(data, modalRef) {
    this.upgradeActionButtonClicked = true;
    this.flagToTriggerChangeEvent = this.flagToTriggerChangeEvent + 1;
    this.planDataToSend = data;
    this.modalRefToSend = modalRef;
  }

  //  Payment Method (Info, Update Card)
  // setUpdateCardVisibility() {
  //   this.isEditPayment = !this.isEditPayment;
  // }

  updatePaymentDetailsFormSubmit() {
    // this.isUpdatePaymentDetailsFormSubmitted = true;

    // if (this.updatePaymentDetailsForm.invalid) {
    //   return;
    // }
    // console.log('valid');
    // console.log(this.updatePaymentDetailsForm.value);

    this.dashboardService.getSubscriptionId().subscribe(response => {
      if (response.statusCode == 200 && response.status == true) {
        const options = {
          key: environment.razorpay_key,
          subscription_id: response.data.subscription_id,
          subscription_card_change: 1,
          name: 'Mindler',
          description: response.data.description,
          image: '/your_logo.png',
          prefill: { name: response.data.name, email: response.data.email },
          theme: { color: '#007fb6' },
          handler: ((razorpayResponse) => {
            const updateCardDetailsPostData = {
              razorpay_payment_id: razorpayResponse.razorpay_payment_id
            };
            this.dashboardService.updateCardDetails(updateCardDetailsPostData).subscribe(response => {
              if (response.statusCode == 200 && response.status == true) {
                this.zone.run(() => {
                  this.apiResponse.last_four = response.data.last_four;
                  this.apiResponse.network = response.data.network;
                });
              }
            });
          })

        };
        const rzp1 = new this.windowRef.nativeWindow.Razorpay(options);
        rzp1.open();
      }
    });
  }

  // Buy More Coupons
  buyMoreCouponsAction() {
    this.dashboardService.getPartnerCouponDetails().subscribe(response => {
      if (response.statusCode == 200 && response.status == false) {
        console.log('no data');
      }
      else if (response.statusCode == 200 && response.status == true) {
        this.couponDetailsAndPriceResponse = response.data;
      }
    });
    this.isBuyMoreButtonClicked = true;
  }

  //  Billing Information
  setBillingInformationVisibility() {
    this.isEditBillingInformation = !this.isEditBillingInformation;

    this.billingInformationForm.patchValue({
      name: this.apiResponse.billing_details.name,
      phone: this.apiResponse.billing_details.phone,
      email: this.apiResponse.billing_details.email,
      gst: this.apiResponse.billing_details.gst
    });
  }

  billingInformationFormSubmit() {
    this.isBillingInformationFormSubmitted = true;

    if (this.billingInformationForm.invalid) {
      return;
    }
    this.billingFormSaveBtnLabel = 'Saving...';

    this.dashboardService.updateBillingInformationDetails(this.billingInformationForm.value).subscribe(response => {
      if (response.statusCode == 200 && response.status == true) {
        this.billingFormSaveBtnLabel = 'Save Changes';

        this.apiResponse.billing_details.name = response.data.billing_details[0].name;
        this.apiResponse.billing_details.phone = response.data.billing_details[0].phone;
        this.apiResponse.billing_details.email = response.data.billing_details[0].email;
        this.apiResponse.billing_details.gst = response.data.billing_details[0].gst;

        console.log(this.apiResponse.billing_details.name);
        this.isEditBillingInformation = !this.isEditBillingInformation;
      }
    });
  }

  //  Send Invoice on Email
  sendBillOnEmail(billId, btnRef) {
    this.sendOnEmailBtnRef = btnRef;

    this.sendOnEmailBtnRef.target.innerText = 'Sending...';

    this.dashboardService.sendBillOnEmail({ id: billId }).subscribe(response => {
      if (response.statusCode == 200 && response.status == true) {
        this.sendOnEmailBtnRef.target.innerText = 'Sent';

        this.sendOnEmailBtnText();
      }
      else if (response.status == false) {
        this.sendOnEmailBtnRef.target.innerText = 'Save Changes';
      }
    });
  }

  sendOnEmailBtnText() {
    setTimeout(() => {
      this.sendOnEmailBtnRef.target.innerText = 'Send on Email';
    }, 5000);
  }

  paginate(event) {
    this.offsetValue = (event.first);

    this.dashboardService.getBills({ offset: this.offsetValue }).subscribe(response => {
      if (response.statusCode == 200 && response.status == true) {
        this.apiResponse.bills = response.data.bills;
        this.noOfPages = response.data.bills_count;
      }
      else if (response.status == false) {
      }
    });
  }

}
